import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWifiOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 5.375c.67-.586 1.466-1.074 2.347-1.464m.153 4.901c.954-.874 2.16-1.47 3.458-1.788M6.5 12.062c2-1.75 5-1.75 7 0m3.75 3.188L7.708 7.024M1.75 1.75l2.347 2.16m0 0 3.61 3.114m-.384-4.056c3.906-.65 8.35.152 10.927 2.407m-6.316 1.568c1.434.293 2.775.916 3.816 1.87M11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
	})]
});
const ForwardRef = forwardRef(SvgWifiOff);
export { ForwardRef as ReactComponent };
